import { writable } from 'svelte/store';
export const videoDevicesStore = writable([]);
export const currentVideoDeviceId = writable(null);
export async function loadVideoDevices() {
    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        videoDevicesStore.set([]);
        devices.forEach(device => {
            if (device.kind === "videoinput") {
                let label = device.label || "Caméra";
                const lower = label.toLowerCase();
                if (lower.includes("front") || lower.includes("avant")) {
                    label = "Caméra Avant";
                }
                else if (lower.includes("back") || lower.includes("arrière")) {
                    label = "Caméra Arrière";
                }
                videoDevicesStore.update(list => [
                    ...list,
                    { id: device.deviceId, label }
                ]);
            }
        });
    }
    catch (err) {
        console.log("Error enumerating devices: ", err);
    }
}
